import React from 'react';
import { Bot, User } from 'lucide-react';

export function ConversationPreview({ conversation = [] }) {
  if (!conversation || conversation.length === 0) {
    return (
      <div style={{ padding: '24px', textAlign: 'center', color: 'var(--text-muted)', fontSize: '0.875rem' }}>
        No chatbot conversation transcript recorded for this lead.
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', backgroundColor: '#F8FAFC', padding: '16px', borderRadius: 'var(--radius-md)', border: '1px solid var(--border-color)' }}>
      {conversation.map((msg, idx) => {
        const isBot = msg.sender === 'bot';
        return (
          <div
            key={idx}
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: '8px',
              alignSelf: isBot ? 'flex-start' : 'flex-end',
              maxWidth: '85%'
            }}
          >
            {isBot && (
              <div style={{ width: 24, height: 24, borderRadius: '50%', backgroundColor: 'var(--color-primary)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#FFF', flexShrink: 0, marginTop: '2px' }}>
                <Bot size={14} />
              </div>
            )}
            <div
              style={{
                padding: '8px 12px',
                borderRadius: 'var(--radius-sm)',
                backgroundColor: isBot ? '#FFFFFF' : 'var(--color-primary-deep)',
                color: isBot ? 'var(--text-main)' : '#FFFFFF',
                fontSize: '0.8125rem',
                boxShadow: isBot ? 'var(--shadow-xs)' : 'none',
                border: isBot ? '1px solid var(--border-color)' : 'none'
              }}
            >
              <div>{msg.text}</div>
              {msg.time && (
                <div style={{ fontSize: '0.65rem', opacity: 0.7, textAlign: 'right', marginTop: '2px' }}>
                  {msg.time}
                </div>
              )}
            </div>
            {!isBot && (
              <div style={{ width: 24, height: 24, borderRadius: '50%', backgroundColor: '#64748B', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#FFF', flexShrink: 0, marginTop: '2px' }}>
                <User size={14} />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
